import React from 'react'
import { Box } from 'components/Layout'
import { useAuth } from '@modmd/data'
import { VaccineCard as VaccineRecordForm } from 'sharedComponents/VaccineRecord'

export const VaccineRecord = () => {
  const auth = useAuth()

  return (
    <Box display="grid">
      <VaccineRecordForm userId={auth.data.User.id} isEditable={false} isPersonal />
    </Box>
  )
}
